import { useRoute } from "wouter";
import { LaporanReport } from "../components/laporan/LaporanReport.js";
import { hitungDariKode } from "../lib/rumusZaka.js";

export function LaporanPage() {
  const [, params] = useRoute("/laporan/:kode");
  const kode = params?.kode ?? "kirana-mockup";
  const hasil = hitungDariKode(kode);

  if (!hasil) {
    return (
      <div className="p-8 text-center text-slate-600">
        Kode laporan tidak dikenali: <span className="font-mono">{kode}</span>
      </div>
    );
  }

  return (
    <LaporanReport
      hasil={hasil}
      meta={{
        nama: kode === "kirana-mockup" ? "Kirana Ayu Pratiwi" : "Contoh Klien",
        usia: "11 tahun",
        kelamin: "P",
        tanggal: "22 Agu 2026",
        kode,
      }}
    />
  );
}
